import { useEffect } from "react";
import { useLocation } from "react-router";

const ScrollToTop = (props: any) => {
  const location = useLocation();
  const scroller = document.getElementById("content") as HTMLElement;

  useEffect(() => {
    scroller?.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [location]);

  return <>{props.children}</>
};

export default ScrollToTop;
